// BlogDetailsVersion2_Funky.jsx
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get_blog } from '../store/reducers/blogClientReducer';
import Heders from '../components/Headers';
import Footer from '../components/Footer';

const BlogDetailsVersion2Funky = () => {
  const { blogId } = useParams();
  const dispatch = useDispatch();
  const { blog, loader } = useSelector((state) => state.blogs);

  useEffect(() => {
    dispatch(get_blog(blogId));
  }, [dispatch, blogId]);

  if (loader) {
    return (
      <>
        <Heders />
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-pink-300 via-purple-300 to-indigo-300">
          <p className="text-2xl font-bold">Loading blog...</p>
        </div>
        <Footer />
      </>
    );
  }

  if (!blog) {
    return (
      <>
        <Heders />
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-pink-300 via-purple-300 to-indigo-300">
          <p className="text-2xl font-bold">Blog not found.</p>
        </div>
        <Footer />
      </>
    );
  }

  const hasImage = blog.images && blog.images.length > 0;

  return (
    <>
      <Heders />
      <div className="min-h-screen w-full bg-gradient-to-br from-indigo-50 to-pink-50 font-[cursive] p-4">
        {/* Funky Hero Section */}
        {hasImage ? (
          <div className="relative w-full h-64 md:h-80 overflow-hidden top-5 rounded-md">
            <img
              src={blog.images[0]}
              alt={blog.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/30 flex items-center left-3 opacity-95">
              <h1
                className="text-4xl sm:text-3xl md:text-5xl font-extrabold text-white text-center px-4"
                style={{ textShadow: '2px 2px 5px rgba(0,0,0,0.5)', paddingTop: '120px' }}
              >
                {blog.title}
              </h1>
            </div>
          </div>
        ) : (
          <div className="py-8 text-center bg-pink-600">
            <h1
              className="text-4xl md:text-5xl font-extrabold text-white"
              style={{ textShadow: '2px 2px 5px rgba(0,0,0,0.5)' }}
            >
              {blog.title}
            </h1>
          </div>
        )}

        <div className="max-w-3xl mx-auto px-4 py-10">
          {/* Funky Header */}
          {blog.header && (
            <h2 className="text-2xl font-bold text-purple-600 text-center mb-4 animate-bounce">
              {blog.header}
            </h2>
          )}

          {/* Subject with a playful background */}
          {blog.subject && (
            <div className="bg-yellow-200 rounded-md p-3 text-center mb-6 shadow-lg hover:shadow-2xl transition-shadow">
              <p className="text-lg text-purple-800 italic">{blog.subject}</p>
            </div>
          )}

          {/* Divider */}
          <div className="w-16 h-1 mx-auto bg-pink-500 my-6 rounded-full"></div>

          {/* Main Content with a subtle gradient background */}
          <div className="leading-8 text-gray-700 text-lg bg-white/60 p-6 rounded-md shadow-md">
            {blog.content}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogDetailsVersion2Funky;
